import { useMutation, useQuery } from "@tanstack/react-query";
import { generateHookExports } from "api/generateExports";
import { createCRUDService } from "api/queryService";
import { API_CONFIG } from "services/apiConfig";
import axios from "../axios";

let baseData = API_CONFIG.WORK_ENVIRONMENT;
const BASE_URL = baseData?.path;
const QUERY_KEY = baseData?.queryKey;

const workEnvironmentService = createCRUDService({
  baseUrl: BASE_URL,
  queryKey: QUERY_KEY,
  custom: {
    getArea: (options = {}) => {
      return useQuery({
        queryKey: [QUERY_KEY],
        queryFn: async () => {
          const res = await axios.get(`${BASE_URL}/get-list-dynamic`, {
            params: { isOnlyArea: true },
          });
          return res.data?.data?.data?.areas ?? {};
        },
        retry: options.retry ?? 1,
        enabled: options.enabled ?? true,
        onError: (error) => {
          triggerToast(error?.data);
        },
      });
    },
    updateArea: (options = {}) =>
      useMutation({
        mutationFn: (payloadObj) =>
          axios
            .put(`${BASE_URL}/update-area`, payloadObj)
            .then((res) => res.data),
        onError: (error) => {
          triggerToast(error?.response?.data || "Update failed");
        },
        ...options,
      }),
    getListDynamic: (params = {}, options = {}) => {
      return useQuery({
        queryKey: [QUERY_KEY, params],
        queryFn: () =>
          axios
            .get(`${BASE_URL}/get-list-dynamic`, { params })
            .then((res) => res.data),
        ...options,
        retry: options.retry ?? 1,
      });
    },
    getByMetaInfo: (params = {}, options = {}) => {
      return useQuery({
        queryKey: [QUERY_KEY, params],
        queryFn: () =>
          axios
            .get(`${BASE_URL}/get-by-meta-info`, { params })
            .then((res) => res.data),
        ...options,
        retry: options.retry ?? 1,
      });
    },
  },
});

export const {
  workEnvironmentList,
  workEnvironmentCreate,
  workEnvironmentGetById,
  workEnvironmentUpdate,
  workEnvironmentUpdateSpecific,
  workEnvironmentDownload,
  workEnvironmentDelete,
  workEnvironmentCount,
  workEnvironmentGetArea,
  workEnvironmentUpdateArea,
  workEnvironmentGetByMetaInfo,
  workEnvironmentGetListDynamic,
} = generateHookExports(workEnvironmentService, "workEnvironment");
